<script lang="ts">
  import editorStore from '@/lib/editor/editor.store';
  import VidImgDialog from '@/pages/thumbPreview/VidImgDialog.svelte';
  import Snapshot from '../../Snapshot.svelte';

  // export let isVidImgDialogOpen = true
  function openVideoSnap() {
    editorStore.toggleStylebar(false);
    editorStore.setPopoverComponent(Snapshot, 'Insert Snapshot');
  }
</script>

<!-- on:click={()=>{isVidImgDialogOpen = true}}  -->
<div class="grid w-full gap-2 px-4 py-4">
  <span class="text-sm font-bold text-zinc-800">Take a snapshot</span>
  <button
    on:click={openVideoSnap}
    class="rounded-lg border border-zinc-200 bg-primary px-4 py-3 text-sm font-bold text-white hover:bg-primary-500"
  >
    Take a Snapshot
  </button>
  <!-- <VidImgDialog bind:isVidImgDialogOpen/> -->
</div>
